import { SmallCloseIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";
import React from "react";
import { FC } from "react";

interface NuSelectItemProps {
	item: { value: string; text: string };
	handleChange: (item: { value: string; text: string }) => void;
	showClose: boolean;
}

const NuSelectItem: FC<NuSelectItemProps> = ({ item, handleChange, showClose }) => {
	return (
		<Box display="flex" justifyContent="space-between" alignItems="center" className="NuSelect_item" key={item.value}>
			{item.text}
			{showClose && (
				<SmallCloseIcon color="red" aria-hidden="true" onClick={() => handleChange(item)} data-testid="nu-select-item-delete" />
			)}
		</Box>
	);
};

export default NuSelectItem;
